<div class="general-panel-width-hack"></div>

<!-- affichage standard sur une seul colonne (affiche de la session normal) -->
<div class="generalPanel" *ngIf="session && simpleColumn && !isMobileDisplay">
    <div class="parameter">
        <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="100">
                <div class="adn-container section">
                    <div *ngIf="session.adn && session.histogramData" class="adn-bar">
                        <table-histogram-chart [showOnlyBar]="true"
                                               [rows]="session.histogramData.rows"
                                               [columns]="session.histogramData.cols"
                                               [values]="session.histogramData.values">
                        </table-histogram-chart>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-sm="column" class="mt-20">
            <div fxFlex="33%">
                <span class="label">{{ 'intensity' | translate }}</span>
                <ng-container *ngIf="isEditable">
                    <mat-slider
                        class="intensity-slider"
                        min="0"
                        max="100"
                        [disabled]="!isEditable"
                        step="1">
<!--                      onIntensitySliderChange.emit($event)-->
                      <input matSliderThumb [(ngModel)]="session.intensity" #slider>
                    </mat-slider>
                    <span class="intensity-value">{{session.intensity}} %</span>
                </ng-container>

                <ng-container *ngIf="!isEditable">
                   <div class="value">{{session.intensity}} %</div>
                </ng-container>
            </div>
            <div fxFlex="33%">
                <ng-container *ngIf="isEditable">
                    <mat-form-field color="primary">
                        <input matInput
                               (ngModelChange)="updateResumedInfo()"
                               type="number"
                               min="1"
                               [placeholder]="'nbRepeatPlaceholder' | translate"
                               [formControl]="nbRepeatFormControl"
                               autocomplete="off">
                        <mat-error *ngIf="nbRepeatFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                        <mat-error *ngIf="nbRepeatFormControl.hasError('min')">{{ 'Min_value' | translate: { value: repeatMinValue } }}</mat-error>
                    </mat-form-field>
                </ng-container>

                <ng-container *ngIf="!isEditable">
                    <div class="label">{{ 'nbRepeatPlaceholder' | translate }}</div>
                    <div class="value">{{ nbRepeatFormControl.value }} x</div>
                </ng-container>
            </div>
            <div fxFlex="33%">
                <div class="total-time-container section">
                    <div>
                        <div class="label">{{ 'totalTime' | translate }}</div>
                        <div class="value">{{ totalTimeFormControl.value | durationVerbose:'seconds' }}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="option-buttons">
        <ng-content select="[mainAction]"></ng-content>
    </div>
</div>

<!-- affichage en mode popup sur 2 colonnes -->

<div class="generalPanel popup" *ngIf="session && !simpleColumn && !isMobileDisplay">
    <div class="title">{{ 'parameters' | translate }}</div>
    <div class="parameter">
        <div fxLayout="row">
            <div fxFlex="100">
                <div class="intensity-container section mb-0">
                    <span class="label">{{ 'intensity' | translate }}</span>
                    <mat-slider
                                class="intensity-slider"
                                min="1"
                                max="100"
                                [disabled]="!isEditable"
                                step="1">
<!--                      (input)="onIntensitySliderChange.emit($event)"-->
<!--                                [value]="session.intensity"-->
                      <input matSliderThumb [(ngModel)]="session.intensity">
                    </mat-slider>
                    <span class="intensity-value">{{session.intensity}} %</span>
                </div>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50">
                <div class="repeat-container section">
                    <div>
                        <div class="label">{{ 'nbRepeatPlaceholder' | translate }}</div>
                        <div class="value">{{ nbRepeatFormControl.value }} x</div>
                    </div>
                </div>
            </div>
            <div fxFlex="50">
                <div class="total-time-container section">
                    <div>
                        <div class="label">{{ 'totalTime' | translate }}</div>
                        <div class="value">{{ totalTimeFormControl.value | durationVerbose:'seconds' }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row" class="mt-20">
            <div fxFlex="100">
                <div class="adn-container section">
                    <span class="label">{{ 'adnOfSession' | translate }}</span>
                    <div *ngIf="session.adn && session.histogramData" class="adn-bar">
                        <table-histogram-chart [showOnlyBar]="true"
                                               [rows]="session.histogramData.rows"
                                               [columns]="session.histogramData.cols"
                                               [values]="session.histogramData.values">
                        </table-histogram-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- affichage en mode mobile -->
<ng-container *ngIf="isMobileDisplay">
    <div class="generalPanel mobile" *ngIf="session && simpleColumn">
        <div class="parameter">
            <div class="adn-container">
                <div *ngIf="session.adn && session.histogramData"
                     class="adn-bar">
                    <table-histogram-chart [showOnlyBar]="true"
                                           [rows]="session.histogramData.rows"
                                           [columns]="session.histogramData.cols"
                                           [values]="session.histogramData.values">
                    </table-histogram-chart>
                </div>
            </div>

            <div class="metrics">
                <div fxLayout="row" fxLayoutAlign="space-between stretch">
                    <div fxFlex="100" class="box">
                        <span class="label">{{ 'intensity' | translate }}</span>
                        <div class="value">{{session.intensity}} %</div>
                    </div>
                    <div fxFlex="100" class="box">
                        <div class="label">{{ 'nbRepeatPlaceholder' | translate }}</div>
                        <div class="value">{{ nbRepeatFormControl.value }} x</div>
                    </div>
                    <div fxFlex="100" class="box last">
                        <div class="label">{{ 'totalTime' | translate }}</div>
                        <div class="value">{{ totalTimeFormControl.value | durationVerbose:'seconds':'minutes' }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
